import React from 'react';

import { ListingsSearchCategory } from '@kamernet/core/Routing/routes/ListingsSearch';

import { ContentCityAntisquat } from './ContentCityAntisquat';
import { ContentCityApartment } from './ContentCityApartment';
import { ContentCityFurnishedApartments } from './ContentCityFurnishedApartments';
import { ContentCityGeneric } from './ContentCityGeneric';
import { ContentCityLongTermRentals } from './ContentCityLongTermRentals';
import { ContentCityRoom } from './ContentCityRoom';
import { ContentCityShortTermRentals } from './ContentCityShortTermRentals';
import { ContentCityStudentHousing } from './ContentCityStudentHousing';
import { ContentCityStudio } from './ContentCityStudio';

export interface ContentCityProps {
  cityName: string;
  citySlug: string;
  mainSearchCategory: ListingsSearchCategory;
}

export const ContentCity = ({
  cityName,
  citySlug,
  mainSearchCategory,
}: ContentCityProps) => {
  switch (mainSearchCategory) {
    case ListingsSearchCategory.Generic:
      return <ContentCityGeneric cityName={cityName} />;
    case ListingsSearchCategory.Room:
      return <ContentCityRoom cityName={cityName} citySlug={citySlug} />;
    case ListingsSearchCategory.Apartment:
      return <ContentCityApartment cityName={cityName} />;
    case ListingsSearchCategory.Studio:
      return <ContentCityStudio cityName={cityName} />;
    case ListingsSearchCategory.Antisquat:
      return <ContentCityAntisquat cityName={cityName} />;
    case ListingsSearchCategory.StudentHousing:
      return <ContentCityStudentHousing cityName={cityName} />;
    case ListingsSearchCategory.FurnishedApartment:
      return <ContentCityFurnishedApartments cityName={cityName} />;
    case ListingsSearchCategory.ShortTermRental:
      return <ContentCityShortTermRentals cityName={cityName} />;
    case ListingsSearchCategory.LongTermRental:
      return <ContentCityLongTermRentals cityName={cityName} />;
    default:
      return null;
  }
};
